// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"NewsArchiveView_Wrapper__1io2T"};